"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const usehooks_ts_1 = require("usehooks-ts");
const config_1 = require("config");
const context_1 = require("context");
const hooks_1 = require("hooks");
const Spinner_1 = __importDefault(require("../../../../../components/Spinner"));
const actions_1 = require("../../../credit_application/actions");
const reducer_1 = require("../../../credit_application/reducer");
const api_1 = require("../utils/api");
const func_1 = require("../utils/func");
const CheckPhoneExpire_1 = __importDefault(require("./CheckPhoneExpire"));
const CheckPhoneMessage_1 = __importDefault(require("./CheckPhoneMessage"));
const CheckPhone = () => {
    // Vars
    const DELAY = 4000; // 1000 = 1 second
    const WIZARD_URL = '/credit-portal/apply/wizard';
    const EXPIRE_MINUTES = 10;
    // Hooks
    const { analytics } = (0, react_1.useContext)(context_1.AnalyticsContext);
    const query = (0, hooks_1.useQuery)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const proveApp = (0, react_redux_1.useSelector)(reducer_1.selectors.proveApp);
    const history = (0, react_router_dom_1.useHistory)();
    const [count, { startCountdown }] = (0, usehooks_ts_1.useCountdown)({
        countStart: 60 * EXPIRE_MINUTES,
        intervalMs: 1000,
    });
    // State
    const [sessionJson] = (0, react_1.useState)(proveApp); // Session
    const [isAvailable, setIsAvailable] = (0, react_1.useState)(null); // Pure Service
    const [isPlaying, setPlaying] = (0, react_1.useState)(true); // Interval Active
    const [isSuccess, setSuccess] = (0, react_1.useState)(false); // Success
    const [isFailed, setFailed] = (0, react_1.useState)(false); // Failed
    const [urlLink, setUrlLink] = (0, react_1.useState)(undefined); // URL Link
    (0, usehooks_ts_1.useInterval)(async () => {
        if (sessionJson) {
            checkTransactionStatus(sessionJson);
        }
        else {
            setPlaying(false);
            return false;
        }
    }, 
    // Delay in milliseconds or null to stop it
    isPlaying ? DELAY : null);
    const checkTransactionStatus = async (sessionJson) => {
        const postResJson = await (0, api_1.getProveTransactionStatus)(sessionJson);
        if (postResJson?.status === 200) {
            const postRes = await postResJson?.json();
            afterResp(postRes);
        }
        else {
            setPlaying(false);
            return false;
        }
    };
    const afterResp = async (postRes) => {
        const currentStatus = (0, func_1.processStatus)(postRes); // Decide status and next step
        let formUrl = WIZARD_URL;
        if (currentStatus) {
            // Store Prove Verify in redux no matter what
            dispatch((0, actions_1.setProveVerify)({
                credit_application_id: postRes?.credit_application_id ?? undefined,
                location_id: postRes?.location_id ?? undefined,
                session_id: postRes?.session_id ?? postRes?.transaction.session_id,
                phone_number: postRes?.phone_number ?? postRes?.transaction.phone,
                ssn_last_4: postRes?.ssn_last_4 ?? postRes?.transaction.ssn_last_4,
                status: postRes?.status,
            }));
            if (currentStatus === 'failed') {
                await analytics?.track('ProveCheckPhoneStatusFail', {});
                setPlaying(false);
                setUrlLink('');
                setFailed(true);
                history.push(formUrl);
            }
            if (currentStatus === 'verified') {
                const storeNum = postRes.ads_store_number; // Store Number
                if (postRes?.location_id !== null && storeNum) {
                    formUrl = (0, config_1.makeStoreUrl)(Number(storeNum));
                }
                if (postRes?.credit_application_id !== null) {
                    formUrl = (0, config_1.makeStoreUrl)(Number(storeNum));
                }
                await analytics?.track('ProveCheckPhoneStatusVerified', {});
                setPlaying(false);
                setUrlLink(formUrl);
                setSuccess(true);
                history.push(formUrl); // Redirect upon success
            }
        }
    };
    const checkProveAvail = async () => {
        const resp = await (0, api_1.getProveAvail)();
        const respJson = await resp.json();
        if (resp?.status === 200 && respJson?.available === true) {
            // Do nothing
        }
        else {
            setIsAvailable(false);
        }
    };
    const handleClick = (0, react_1.useCallback)(() => {
        analytics?.track('ClickIDidNotReceiveText', {});
        dispatch((0, actions_1.setProveFail)({
            ...sessionJson,
        })); // Set Prove Fail
        if (urlLink) {
            history.push(urlLink);
        }
        else {
            const hasStoreNum = query.get('store');
            if (hasStoreNum) {
                history.push((0, config_1.makeStoreUrl)(Number(hasStoreNum)));
            }
            else {
                history.push(WIZARD_URL);
            }
        }
    }, [urlLink, sessionJson, analytics]);
    const init = async () => {
        startCountdown(); // Start countdown to form expiration
        if (sessionJson && sessionJson?.phone_number) {
            analytics?.track('ProveCheckPhoneInitStart', {});
            setIsAvailable(true);
            setPlaying(true);
            // Check Immediately
            checkTransactionStatus(sessionJson);
        }
        else {
            setIsAvailable(false);
            setFailed(true);
            analytics?.track('ProveCheckPhoneInitFail', {});
        }
    };
    // Effects
    (0, react_1.useEffect)(() => {
        init();
    }, []);
    (0, react_1.useEffect)(() => {
        if (count === 0) {
            setPlaying(false);
            setFailed(true); // Expire form
        }
        // After 2 sec check Transaction Status
        if (count === 598) {
            checkTransactionStatus(sessionJson);
        }
        // After 2 min check if Prove is available
        if (count === 480) {
            checkProveAvail();
        }
    }, [count, sessionJson]);
    (0, react_1.useEffect)(() => {
        // Start again if no session
        if (isAvailable && !sessionJson?.phone_number) {
            dispatch((0, actions_1.clearProveApp)()); // Clear Prove App
        }
        if (isAvailable === false) {
            dispatch((0, actions_1.setProveFail)({
                ...sessionJson,
            })); // Set Prove Fail
            dispatch((0, actions_1.clearProveApp)()); // Clear Prove App
            history.push('/credit-portal/apply/wizard');
        }
    }, [isAvailable, sessionJson]);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [isAvailable && sessionJson && sessionJson?.phone_number && ((0, jsx_runtime_1.jsx)(CheckPhoneMessage_1.default, { phone: sessionJson.phone_number.slice(-4), success: isSuccess, failed: isFailed, handleClick: handleClick, authUrl: sessionJson?.auth_url })), ((isAvailable && !sessionJson?.phone_number) || isFailed) && ((0, jsx_runtime_1.jsx)(CheckPhoneExpire_1.default, {})), isAvailable === null && (0, jsx_runtime_1.jsx)(Spinner_1.default, {})] }));
};
exports.default = CheckPhone;
